import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Menu, MenuItem, Fade } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import CustomTableV2 from "../../common/CustomTableV2";
import CustomSliderModalV2 from "../../common/CustomSliderModalV2";
import TRSendEmailForm from "./components/TRSendEmailForm";

import { GetUsersTherapistEmailLog } from "../../redux/user/actions";
import { GetEmailTemplates } from "../../redux/emailTemplate/actions";

import "./style.css";


function TherapistReminder(props) {
    // MENU STATES
    const [anchorEl, setAnchorEl] = useState(null);
    const [therapist, setTherapist] = useState({})
    const [currentIndex, setCurrentIndex] = useState('');
    const [emailTemplate, setEmailTemplate] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event, index) => {
        setCurrentIndex(index)
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    // SLIDER STATES
    const [showModal, setShowModal] = useState(false)
    const [showType, setShowType] = useState(false)

    useEffect(() => {
        const cb = async () => {
            const res = await props.GetEmailTemplates(1, 100, { tag: "therapist-email-reminder" }, null, true);
            setEmailTemplate(res[0]);
        }

        cb();
    }, []);

    return (
        <div className="main-container" id="therapist-reminder">
            <Fade in>
                <div>
                    <CustomTableV2
                        title="Therapists"
                        description=""
                        store={props.User?.therapistEmailLog}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "Therapist", value: "first_name", },
                                { title: "Email Address", value: "email_address", },
                                { title: "Company" },
                                { title: "Sent" },
                                { title: "Delivered" },
                                { title: "Opened" },
                                { title: "Clicked" },
                                { title: "Registered" },
                                { title: "Patients" },
                                { title: "Unnotified" },
                                { title: "" },
                            ],
                            body: (tel, i) => {

                                let sent = tel?.sentEmailToPatients?.length, delivered = 0, opened = 0, registered = 0, clicked = 0;
                                for (let x = 0; x < sent; x++) {
                                    if (tel?.sentEmailToPatients?.[x]?.date_clicked) {
                                        clicked++;
                                    }

                                    if (tel?.sentEmailToPatients?.[x]?.date_opened) {
                                        opened++;
                                    }

                                    if (tel?.sentEmailToPatients?.[x]?.date_delivered) {
                                        delivered++;
                                    }

                                    if (tel?.sentEmailToPatients?.[x]?.date_registered) {
                                        registered++;
                                    }
                                }

                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{`${tel.first_name?.toUpperCase()} ${tel.last_name?.toUpperCase()}`}</h5></td>
                                        <td><h5>{tel.email_address}</h5></td>
                                        <td><h5>{tel.name?.toUpperCase()}</h5></td>
                                        <td><h5>{sent}</h5></td>
                                        <td><h5>{delivered}</h5></td>
                                        <td><h5>{opened}</h5></td>
                                        <td><h5>{clicked}</h5></td>
                                        <td><h5>{registered}</h5></td>
                                        <td><h5>{tel?.allPatients?.length}</h5></td>
                                        <td><h5>{tel?.unsendPatients?.length}</h5></td>
                                        <td>
                                            <h5>
                                                <MoreHorizIcon
                                                    id="basic-button"
                                                    onClick={(e) => handleClick(e, i)}
                                                    sx={{ fontSize: 40, cursor: 'pointer' }}
                                                />
                                                {i === currentIndex && (
                                                    <Menu
                                                        sx={{ zIndex: 800 }}
                                                        id="basic-menu"
                                                        anchorEl={anchorEl}
                                                        open={open}
                                                        onClose={handleClose}
                                                        MenuListProps={{
                                                            'aria-labelledby': 'basic-button',
                                                        }}
                                                    >

                                                        <MenuItem onClick={() => {
                                                            handleClose();
                                                            setShowModal(true);
                                                            setTherapist(tel);
                                                        }}> Send Email</MenuItem>

                                                    </Menu>
                                                )}
                                            </h5>
                                        </td>
                                    </tr>
                                )
                            }
                        }}
                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetUsersTherapistEmailLog(page, count, { ...filter, "users.therapist_id": '!null' }, sort);
                            }
                        }}
                    />
                </div>
            </Fade>

            <CustomSliderModalV2 show={showModal} setShow={setShowModal} title={""}>
                <TRSendEmailForm therapist={therapist} emailTemplate={emailTemplate} setShowModal={setShowModal} />
            </CustomSliderModalV2>

        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User
})

export default connect(mapStateToProps, {
    GetUsersTherapistEmailLog,
    GetEmailTemplates,
})(TherapistReminder);